import * as _ from "lodash";
import * as Redux from "redux";

import { PaginatedParams } from "src/library/utils";
import { ListActions } from "src/core/lists/store/lists.actions";
import * as AT from "src/core/lists/store/lists.constants";
import {
  formatOrderLineFromPrice,
  recalculateOrderLine
} from "src/core/prices/utils";
import { IProduct } from "src/core/products/api/products.api";

import {
  IList,
  IListLine
} from "../api/lists.api";

export interface IListsStore {
  lists?: IList[];
  currentList: ICurrentList;
}

export interface ICurrentList {
  data: IList | null;
  saved: boolean;
  mode: ListMode;
}

export type ListMode = "edit" | "view";

export const initialListState: IListsStore = {
  currentList: {
    data: null,
    saved: true,
    mode: "view"
  },
  lists: []
};

export const defaultPagination: PaginatedParams<IList> = {
  page: 0,
  limit: 10,
  offset: 0,
  sort: [ [ "updatedAt", "DESC" ] ]
};

const changeProductQuantity = (listLines: IListLine[], product: IProduct, quantity: number, discountValue = 0) => {
  const prodIndex = _.findIndex(listLines, line => line.productId === product.id);
  const existingPrice = product.prices && product.prices[ 0 ];

  if (prodIndex !== -1) {
    if (existingPrice) {
      const newOrderLineValues = formatOrderLineFromPrice(existingPrice, {
        ...listLines[ prodIndex ],
        quantity
      }, discountValue);

      const priceUpdates = {
        quantity,
        totalPrice: newOrderLineValues.totalPrice,
        price: newOrderLineValues.price,
        totalVatValue: newOrderLineValues.totalVatValue
      };

      listLines[ prodIndex ] = {
        ...listLines[ prodIndex ],
        ...priceUpdates
      };
    }
  } else {
    if (existingPrice) {
      // new product insertion
      listLines.push(
        formatOrderLineFromPrice(existingPrice, {
          productId: product.id,
          quantity,
          product
        }, discountValue)
      );
    }
  }

  if (quantity <= 0) {
    listLines = _.filter(listLines, ol => ol.productId !== product.id);
  }

  return listLines;
};

export const lists: Redux.Reducer<IListsStore> = (state: IListsStore = initialListState, action: ListActions): IListsStore => {
  // handle the data structure change to orders
  if (!state.currentList) {
    state = {
      ...state,
      currentList: initialListState.currentList
    };
  }

  switch (action.type) {
    case AT.UPDATE_LIST_LINE: {
      if (!state.currentList.data) {
        return state;
      }
      const listLines = changeProductQuantity(state.currentList.data?.listLines || [], action.product, action.newQuantity, state.currentList.data.branch?.discount);

      return {
        ...state,
        currentList: {
          ...state.currentList,
          saved: false,
          data: {
            ...state.currentList.data,
            listLines: [ ...listLines ]
          }
        }
      };
    }

    case AT.SET_CURRENT_LIST:
      // if (action.list && action.list.data.schedule && action.list.data.schedule.scheduleDays) {
      //   // @ts-ignore
      //   action.list.data.schedule.scheduleDays = _.map(action.list.data.schedule.scheduleDays, scheduleDay => (scheduleDay.weekDay - 1) as Day);
      // }
      return {
        ...state,
        currentList: action.list || initialListState.currentList
      };

    case AT.SET_LISTS:
      return {
        ...state,
        lists: action.lists
      };

    case AT.UPDATE_CUSTOMER_REFERENCE:
      if (state.currentList.data) {
        return {
          ...state,
          currentList: {
            ...state.currentList,
            saved: false,
            mode: "edit",
            data: {
              ...state.currentList.data,
              customerReference: action.reference
            }
          }
        };
      }

      return state;

    case AT.UPDATE_LIST_ROW:
      return {
        ...state,
        lists: _.map(state.lists, list => (list.id === action.list.id ? action.list : list))
      };

    case AT.PURGE_LISTS:
      return initialListState;
    default:
      return state;
  }
};
